import React from 'react';
import { FlexGrid, getClassNameFactory, Tabs } from '@dcl/ui';
import { ISupportHoursTabsProps } from './types';
import { SupportHoursTable } from '../SupportHoursTable/SupportHoursTable';
import './SupportHoursTabs.css';

export const SupportHoursTabs: React.FC<ISupportHoursTabsProps> = (props) => {
  const getClassName = getClassNameFactory(SupportHoursTabs.displayName);
  const { data, apiUrl } = props;

  return (
    <FlexGrid.Col
      xs={12}
      lg={12}
      md={12}
      className={getClassName({ descendantName: 'tabs' })}
    >
      {data && (
        <Tabs
          layoutVariant={null}
          ariaLabelText="Tabs Information"
          enableArrowKeyCarousel={true}
        >
          {data.length > 0 &&
            data.map((data: any, index: number) => {
              const transformedUrl = `${apiUrl}?productKey=${data.scheduleGroupID}`;
              return (
                data.tabLabel && (
                  <Tabs.Panel
                    key={`tab${index + 1}`}
                    id={`tab${index + 1}`}
                    tabTitle={data.tabLabel}
                    segment={`segment-${index + 1}`}
                    subSegment={`subsegment-${index + 1}`}
                  >
                    <SupportHoursTable
                      apiUrl={transformedUrl}
                      searchTitle="Search"
                      normalHours={data.supportType}
                      phNumber={
                        data.phoneNumberValue + data.phoneNumberExtensionValue
                      }
                      normalHoursLabel={data.normalHoursLabel}
                      phoneNumberLabel={data.phoneNumberLabel}
                    ></SupportHoursTable>
                  </Tabs.Panel>
                )
              );
            })}
        </Tabs>
      )}
    </FlexGrid.Col>
  );
};

SupportHoursTabs.displayName = 'SupportHoursTabs';
